export { InputPhoneComponent, inputPhoneValidator, inputPhoneFormValidator } from './input-phone';
